<div class="header-wrapper">
  <div layout layout-space-between layout-align-items-center>
    <div>
      <rt-heading variant="large heading"
        >{{ 'tlc.ask_hr.user_requests.heading' | translate }}
      </rt-heading>
      <p>
        {{ 'tlc.ask_hr.user_requests.subheading' | translate }}
      </p>
    </div>
  </div>
</div>
<rt-tabs>
  <rt-tab routerLinkActive="active" routerLink="./forms" margin-left>
    {{ 'tlc.ask_hr.user_requests.make_a_request' | translate }}
  </rt-tab>
  <rt-tab routerLinkActive="active" routerLink="./tickets">
    {{ 'tlc.ask_hr.user_requests.my_requests' | translate }}
  </rt-tab>
</rt-tabs>
<rtc-detached-router-outlet />
